import React from "react";
import { Helmet } from 'react-helmet';
import Slider from "../inc/Slider";
import SliderMain from "../inc/SliderMain";
import {Link} from "react-router-dom";
import CardsInfo from "./inc/CardsInfo";
import CardsServices from "./inc/CardsServices";
import CardsEtelaieh from "./inc/CardsEtelaieh";
import slide1 from '../images/slide1.jpg'
import slide2 from '../images/slide2.jpg'
import slide3 from '../images/slide3.jpg'
import '../../main.css';


function Home(){

    const slides = [slide1,slide2,slide3];

return (

  <div>

<Helmet>
        <title>شرکت پویارایانه فرتاک - سیستم یکپارچه مالی راینو</title>
        <meta name="description" content="شرکت فنی مهندسی پویارایانه فرتاک تولید کننده سیستم های اتوماسیون مالی و درمانی " />
        <meta name="keywords" content="سیستم مالی , حسابداری , خریدوفروش ,دریافت و پرداخت ,حقوق دستمزد,تولیدی ,پیمانکاری ,اموال(دارایی ثابت),شرکت پخش,انبارداری ,مودیان,راینو" />
</Helmet>

<div> 
  <SliderMain images={slides} />
</div>


<CardsEtelaieh/>

<CardsInfo/>

<section className="section bg-c-light boder-top" >
<div className="container">
   <div className="row">

    <div className="col-md-12 text-center">
  
     <h3 className="main-heading "> سیستم یکپارچه مالی راینو </h3>
     <div className="underline mx-auto"> </div>
     
     <p>
     سیستم حسابداری راینو یک راه‌حل جامع و کارآمد برای مدیریت مالی کسب‌وکارها است. این سیستم شامل قابلیت‌های پیشرفته حسابداری خرید و فروش، دریافت و پرداخت، و همچنین مدیریت حقوق و دستمزد است. با استفاده از این نرم‌افزار، کاربران می‌توانند به راحتی تراکنش‌های مالی را ثبت و پیگیری کنند و از گزارش‌های دقیق و تحلیلی بهره‌مند شوند. علاوه بر این، سیستم راینو امکان مدیریت تولید و دارایی‌های ثابت را نیز فراهم می‌آورد، که به کسب‌وکارها کمک می‌کند تا در فرآیندهای مالی خود کارایی بیشتری داشته باشند و تصمیم‌گیری‌های بهتری انجام دهند.
     </p>
     <Link to="/AboutUs" className="btn btn-warning shadow">اطلاعات بیشتر</Link>

    </div>

   </div>
</div>

</section>


<CardsServices/>

  </div>

    )

}

export default Home;